import type React from 'react';

import { PermissionsVisibility } from '@vlabs/api/artemy/model';
import { Radio } from '@vlabs/uikit/components/controls/radio';
import type { WithDataTestid } from '@vlabs/uikit/types';

import st from './IgnoreVisibilityField.module.sass';
import { useEditPermissionsTranslation } from '../i18n';
import { useEditPermissionsFormContext } from '../useEditPermissionsFormContext';

const visibilityOptions = [
  {
    value: PermissionsVisibility.basic,
    titleKey: 'visibility.options.basic',
    descriptionKey: 'visibility.descriptions.basic',
  },
  {
    value: PermissionsVisibility.local,
    titleKey: 'visibility.options.local',
    descriptionKey: 'visibility.descriptions.local',
  },
  {
    value: PermissionsVisibility.global,
    titleKey: 'visibility.options.global',
    descriptionKey: 'visibility.descriptions.global',
  },
] as const;

interface IgnoreVisibilityFieldProps extends WithDataTestid {
  disabled?: boolean;
}

function IgnoreVisibilityField({
  disabled = false,
  'data-testid': dataTestId = undefined,
}: IgnoreVisibilityFieldProps): React.JSX.Element {
  const { t } = useEditPermissionsTranslation();
  const { watch, setValue } = useEditPermissionsFormContext();
  const visibility = watch('visibility');

  return (
    <div
      className={st.Root}
      data-testid={dataTestId}
    >
      <span className={st.Title}>{t('visibility.title')}</span>
      <div className={st.Options}>
        {visibilityOptions.map(({ value, titleKey, descriptionKey }) => (
          <div
            className={st.Option}
            key={value}
          >
            <Radio
              checked={visibility === value}
              disabled={disabled}
              id={`visibility-${value}`}
              name="visibility"
              onChange={() => setValue('visibility', value)}
              value={value}
            />
            <label
              className={st.OptionText}
              htmlFor={`visibility-${value}`}
            >
              <span className={st.OptionTitle}>{t(titleKey)}</span>
              <span className={st.OptionDescription}>{t(descriptionKey)}</span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export { IgnoreVisibilityField };
